// // import React, { useMemo } from 'react';
// // import {
// //   Box,
// //   Typography,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   Divider,
// //   useTheme,
// //   Avatar,
// //   CircularProgress,
// //   Alert
// // } from '@mui/material';
// // import PersonIcon from '@mui/icons-material/Person';
// // import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
// // import { gql, useQuery } from '@apollo/client';

// // const GET_TENANT_ACTIVITY_LOGS = gql`
// //   query GetTenantActivityLogs($tenantId: ID!, $limit: Int) {
// //     tenantActivityLogs(tenantId: $tenantId, limit: $limit) {
// //       id
// //       activityType
// //       performedByUser { id name photo }
// //       targetUser { id name }
// //       createdAt
// //       details
// //     }
// //   }
// // `;

// // interface RecentActivityProps {
// //   currentTenantId: string | null;
// // }

// // interface ActivityItem {
// //   id: string;
// //   description: string;
// //   date: string;
// //   time: string;
// //   actorType: 'user' | 'system';
// //   actorName: string;
// //   actorAvatarUrl?: string;
// // }

// // const generateActionMessage = (log: any): string => {
// //   const { activityType, performedByUser, targetUser, details } = log;
// //   const performerName = performedByUser?.name || 'System';
// //   const targetName = targetUser?.name || 'a user';
// //   switch (activityType) {
// //     case 'USER_ADDED_TO_TENANT':
// //       return `New user "${targetName}" was added.`;
// //     case 'USER_REMOVED_FROM_TENANT':
// //       return `User "${targetName}" was removed.`;
// //     case 'USER_ROLE_IN_TENANT_CHANGED':
// //       const newRole = details?.newRole || 'a new role';
// //       return `Role for "${targetName}" was changed to ${newRole}.`;
// //     case 'TENANT_SETTINGS_UPDATED':
// //       return `Tenant settings were updated.`;
// //     case 'USER_INVITED_TO_TENANT':
// //    return `${performerName} invited ${targetName} to the tenant.`;
// //     case 'USER_ACCEPTED_INVITATION':
// //   return `${performerName} accepted the invitation and joined the tenant.`;
// //     case 'DATA_SOURCE_CREATED':
// //       return `New data source "${details?.name || 'unnamed'}" was added.`;
// //     case 'DATA_SOURCE_DELETED':
// //        return `Data source "${details?.name || 'unnamed'}" was deleted.`;
// //     default:
// //       return `${activityType.replace(/_/g, ' ').toLowerCase()}`;
// //   }
// // };

// // const formatActivityTimestamp = (isoString: string): { date: string, time: string } => {
// //   if (!isoString) return { date: '', time: '' };
// //   try {
// //     const date = new Date(isoString);
// //     const formattedDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });
// //     const formattedTime = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
// //     return { date: formattedDate, time: formattedTime };
// //   } catch (e) {
// //     console.error("Error formatting timestamp:", isoString, e);
// //     return { date: 'Invalid Date', time: 'Invalid Time' };
// //   }
// // };

// // const RecentActivity: React.FC<RecentActivityProps> = ({ currentTenantId }) => {
// //   const theme = useTheme();

// //   const { loading, error, data } = useQuery(GET_TENANT_ACTIVITY_LOGS, {
// //     variables: { tenantId: currentTenantId, limit: 5 },
// //     skip: !currentTenantId,
// //     fetchPolicy: 'network-only',
// //   });

// //   const activities = useMemo(() => {
// //     if (!data?.tenantActivityLogs) return [];
// //     return data.tenantActivityLogs.map((log: any): ActivityItem => {
// //       const { date, time } = formatActivityTimestamp(log.createdAt);
// //       const isSystem = !log.performedByUser;
// //       return {
// //         id: log.id,
// //         description: generateActionMessage(log),
// //         date,
// //         time,
// //         actorType: isSystem ? 'system' : 'user',
// //         actorName: isSystem ? 'System' : log.performedByUser.name || 'Unknown User',
// //         actorAvatarUrl: isSystem ? undefined : log.performedByUser.photo,
// //       };
// //     });
// //   }, [data]);

// //   // --- MODIFICATION 1: The renderActorInfo function is updated ---
// //   const renderActorInfo = (activity: ActivityItem) => {
// //     if (activity.actorType === 'system') {
// //       return (
// //         <Box sx={{ display: 'flex', alignItems: 'center' }}>
// //           <SettingsApplicationsIcon sx={{ fontSize: '1rem', color: 'text.secondary', mr: 0.5 }} />
// //           <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>
// //             {activity.actorName}
// //           </Typography>
// //         </Box>
// //       );
// //     }
    
// //     // For user actor type, we wrap everything in a flexible Box
// //     return (
// //       <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, minWidth: 0 }}>
// //         {activity.actorAvatarUrl ? (
// //           <Avatar alt={activity.actorName} src={activity.actorAvatarUrl} sx={{ width: 16, height: 16, mr: 0.5, fontSize: '0.75rem' }} />
// //         ) : (
// //           <Avatar sx={{ width: 16, height: 16, mr: 0.5, bgcolor: 'primary.light', fontSize: '0.75rem' }}>
// //             <PersonIcon sx={{ fontSize: '0.5rem' }} />
// //           </Avatar>
// //         )}
// //         <Typography 
// //           variant="caption" 
// //           sx={{ 
// //             color: 'text.secondary',
// //             fontSize: '10px', // Consistent font size
// //             whiteSpace: 'nowrap', // Prevents the name from wrapping
// //             overflow: 'hidden', // Required for text-overflow
// //             textOverflow: 'ellipsis', // Adds "..." if name is too long
// //           }}
// //         >
// //           {activity.actorName}
// //         </Typography>
// //       </Box>
// //     );
// //   };

// //   const renderContent = () => {
// //     if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress size={24} /></Box>;
// //     if (error) return <Alert severity="error" sx={{ m: 1 }}>Failed to load activities.</Alert>;
// //     if (activities.length === 0) return <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>No recent activities to show.</Typography>;
    
// //     return (
// //       <List disablePadding>
// //         {activities.map((activity: ActivityItem, index: number) => (
// //           <React.Fragment key={activity.id}>
// //             <ListItem
// //               disableGutters
// //               sx={{ py: 1.5, alignItems: 'flex-start', flexDirection: 'column' }}
// //             >
// //               <ListItemText
// //                 primary={activity.description}
// //                 // --- MODIFICATION 2: Moved fontSize into the sx prop for correctness ---
// //                 primaryTypographyProps={{ 
// //                   variant: 'body2', 
// //                   fontWeight: 400, 
// //                   sx: { 
// //                     mb: 0.5,
// //                     fontSize: '12px' 
// //                   } 
// //                 }}
// //                 secondary={
// //                   <Box component="span" sx={{ display: 'flex', alignItems: 'center', mt: 0.5, width: '100%' }}>
// //                     <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px', whiteSpace: 'nowrap' }}>
// //                       {activity.date} &bull; {activity.time}
// //                     </Typography>
// //                     <Typography variant="caption" sx={{ color: 'text.disabled', mx: 0.5, fontSize: '10px' }}>|</Typography>
// //                     {renderActorInfo(activity)}
// //                   </Box>
// //                 }
// //               />
// //             </ListItem>
// //             {index < activities.length - 1 && <Divider component="li" />}
// //           </React.Fragment>
// //         ))}
// //       </List>
// //     );
// //   };

// //   return (
// //     <Box>
// //       <Typography gutterBottom sx={{ fontWeight: 400, fontFamily: 'inter' }}>Recent Activities</Typography>
// //       <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
// //         Showing {loading || error ? 0 : activities.length} recent activities
// //       </Typography>
// //       {renderContent()}
// //     </Box>
// //   );
// // };

// // export default RecentActivity;

// import React, { useMemo } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   useTheme,
//   Avatar,
//   CircularProgress,
//   Alert,
//   Stack,
// } from '@mui/material';
// import PersonIcon from '@mui/icons-material/Person';
// import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
// import { gql, useQuery } from '@apollo/client';

// const GET_TENANT_ACTIVITY_LOGS = gql`
//   query GetTenantActivityLogs($tenantId: ID!, $limit: Int) {
//     tenantActivityLogs(tenantId: $tenantId, limit: $limit) {
//       id
//       activityType
//       performedByUser { id name photo }
//       targetUser { id name email photo }
//       createdAt
//       details
//     }
//   }
// `;

// interface RecentActivityProps {
//   currentTenantId: string | null;
// }

// interface ActivityItem {
//   id: string;
//   description: string;
//   date: string;
//   time: string;
//   actorType: 'user' | 'system';
//   actorName: string;
//   actorAvatarUrl?: string;
//   logDetails?: any;
// }

// const generateActionMessage = (log: any): string => {
//   const { activityType, performedByUser, targetUser, details } = log;
//   const performerName = performedByUser?.name || 'System';
//   const targetName = targetUser?.name || details?.deletedUserName || 'a user';

//   switch (activityType) {
//     case 'USER_ADDED_TO_TENANT':
//       return `New user added by ${performerName}`;
//     case 'USER_REMOVED_FROM_TENANT':
//       return `User deleted by ${performerName}`;
//     case 'USER_ROLE_IN_TENANT_CHANGED':
//       return `Role changed for ${targetName} by ${performerName}`;
//     case 'TENANT_SETTINGS_UPDATED':
//       return `Tenant settings updated by ${performerName}`;
//     case 'USER_INVITED_TO_TENANT':
//       return `${targetName} invited to tenant by ${performerName}`;
//     case 'USER_ACCEPTED_INVITATION':
//       return `Email Invitation accepted by ${targetName}`;
//     case 'DATA_SOURCE_CREATED':
//       return `New data source "${details?.name || 'unnamed'}" was added by ${performerName}`;
//     case 'DATA_SOURCE_DELETED':
//       return `Data source "${details?.name || 'unnamed'}" was deleted by ${performerName}`;
//     default:
//       return `${activityType.replace(/_/g, ' ').toLowerCase()} by ${performerName}`;
//   }
// };

// const formatLogDateForGrouping = (isoString: string): string => {
//   if (!isoString) return 'Invalid Date';
//   return new Date(isoString).toLocaleDateString('en-GB', {
//     day: 'numeric',
//     month: 'long',
//     year: 'numeric',
//   }).toUpperCase();
// };

// const formatActivityTimestamp = (isoString: string): { date: string, time: string } => {
//   if (!isoString) return { date: '', time: '' };
//   try {
//     const date = new Date(isoString);
//     const formattedDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });
//     const formattedTime = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
//     return { date: formattedDate, time: formattedTime };
//   } catch (e) {
//     console.error("Error formatting timestamp:", isoString, e);
//     return { date: 'Invalid Date', time: 'Invalid Time' };
//   }
// };

// const groupLogsByDate = (logs: any[]): Record<string, any[]> => {
//   if (!logs) return {};
//   return logs.reduce((acc, log) => {
//     const dateKey = formatLogDateForGrouping(log.createdAt);
//     if (!acc[dateKey]) acc[dateKey] = [];
//     acc[dateKey].push(log);
//     return acc;
//   }, {} as Record<string, any[]>);
// };

// const roleDotColors: { [key: string]: string } = {
//   Editor: '#0064FF',
//   Viewer: '#6C737F',
//   Admin: '#0064FF',
// };

// const RoleDisplay: React.FC<{ role: string }> = ({ role }) => {
//   const capitalizedRole = role ? role.charAt(0).toUpperCase() + role.slice(1).toLowerCase() : 'N/A';
//   return (
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', backgroundColor: roleDotColors[capitalizedRole] || '#6C737F', mr: 0.5 }} />
//       <Typography variant="caption" sx={{ color: '#344054', fontWeight: 400, fontSize: '10px' }}>{capitalizedRole}</Typography>
//     </Box>
//   );
// };

// const ActivityIcon: React.FC<{ activityType: string }> = ({ activityType }) => {
//   let iconSrc = '/icons/edit-al.svg';

//   if (activityType.includes('ADD') || activityType.includes('INVITE') || activityType.includes('CREATED')) {
//     iconSrc = '/icons/add-al.svg';
//   } else if (activityType.includes('REMOVED') || activityType.includes('DELETED')) {
//     iconSrc = '/icons/delete-al.svg';
//   } else if (activityType.includes('ROLE') || activityType.includes('UPDATED')) {
//     iconSrc = '/icons/edit-al.svg';
//   } else if (activityType.includes('ACCEPT')) {
//     iconSrc = '/icons/email-al.svg';
//   }

//   return (
//     <Box sx={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <img src={iconSrc} alt={`${activityType} icon`} style={{ width: '14px', height: '14px' }} />
//     </Box>
//   );
// };

// const LogDetailContent: React.FC<{ log: any }> = ({ log }) => {
//   const { activityType, targetUser, details } = log;

//   const typesWithDetailBox = [
//     'USER_ADDED_TO_TENANT',
//     'USER_REMOVED_FROM_TENANT',
//     'USER_ROLE_IN_TENANT_CHANGED',
//     'USER_INVITED_TO_TENANT',
//   ];

//   if (!typesWithDetailBox.includes(activityType)) {
//     return null;
//   }

//   const userToShow = {
//     name: details?.deletedUserName || targetUser?.name,
//     email: details?.deletedUserEmail || targetUser?.email,
//     photo: details?.deletedUserPhoto || targetUser?.photo,
//     role: details?.newRole || details?.role || (activityType === 'USER_INVITED_TO_TENANT' ? details?.roleInTenant : 'Editor')
//   };

//   let barColor = '#F79009';
//   if (activityType === 'USER_ADDED_TO_TENANT' || activityType === 'USER_INVITED_TO_TENANT') {
//     barColor = '#0064FF';
//   } else if (activityType === 'USER_REMOVED_FROM_TENANT') {
//     barColor = '#D92D20';
//   }

//   return (
//     <Box sx={{
//       position: 'relative',
//       ml: '24px', // This creates the indent for the detail box relative to its ListItem
//       mt: 0.8,
//       bgcolor: '#FAFAFA',
//       borderRadius: '6px',
//       p: 1,
//       pl: '18px',
//     }}>
//       <Box sx={{
//         position: 'absolute',
//         left: '6px',
//         top: 6,
//         bottom: 6,
//         width: '2px',
//         bgcolor: barColor,
//         borderRadius: '2px',
//       }} />

//       {(() => {
//         switch (activityType) {
//           case 'USER_ADDED_TO_TENANT':
//           case 'USER_REMOVED_FROM_TENANT':
//           case 'USER_INVITED_TO_TENANT':
//             if (!userToShow.name) return null;
//             return (
//               <Stack direction="row" spacing={1} alignItems="center">
//                 <Avatar src={userToShow.photo} sx={{ width: 24, height: 24 }} />
//                 <Box>
//                   <Typography variant="body2" sx={{ fontWeight: 400, color: '#344054', fontSize: '11px' }}>{userToShow.name}</Typography>
//                   <Typography variant="caption" sx={{ color: '#667085', fontSize: '10px' }}>{userToShow.email}</Typography>
//                 </Box>
//               </Stack>
//             );
//           case 'USER_ROLE_IN_TENANT_CHANGED':
//             return (
//               <Stack direction="row" spacing={0.5} alignItems="center">
//                 <RoleDisplay role={details?.oldRole || 'Role'} />
//                 <Typography sx={{ color: '#667085', fontSize: '12px' }}>»</Typography>
//                 <RoleDisplay role={details?.newRole || 'Role'} />
//               </Stack>
//             );
//           default:
//             return null;
//         }
//       })()}
//     </Box>
//   );
// };


// const RecentActivity: React.FC<RecentActivityProps> = ({ currentTenantId }) => {
//   const theme = useTheme();

//   // Define a consistent horizontal padding for titles and content inside list items
//   const componentPaddingX = 2; // Corresponds to theme.spacing(2) which is 16px by default

//   const { loading, error, data } = useQuery(GET_TENANT_ACTIVITY_LOGS, {
//     variables: { tenantId: currentTenantId, limit: 5 },
//     skip: !currentTenantId,
//     fetchPolicy: 'network-only',
//   });

//   const groupedActivities = useMemo(() => {
//     if (!data?.tenantActivityLogs) return {};
//     return groupLogsByDate(data.tenantActivityLogs);
//   }, [data]);


//   const renderContent = () => {
//     if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}><CircularProgress size={20} /></Box>;
//     if (error) return <Alert severity="error" sx={{ m: 0.5, fontSize: '0.8rem' }}>Failed to load activities.</Alert>;
//     if (Object.keys(groupedActivities).length === 0) return <Typography variant="body2" color="text.secondary" sx={{ p: 1, textAlign: 'center', fontSize: '0.8rem' }}>No recent activities to show.</Typography>;

//     return (
//       // The List component itself should not have horizontal padding if items are to be edge-to-edge
//       <List disablePadding sx={{ width: '100%' }}> 
//         {Object.entries(groupedActivities).map(([date, logs]) => (
//           <React.Fragment key={date}>
//             {/* Date Box: This ListItem should go full width, with internal content padded */}
//             <ListItem sx={{ py: 0.5, px: componentPaddingX, bgcolor: '#FAFAFA', borderTop: '1px solid #EAECF0', borderBottom: '1px solid #EAECF0' }}>
//                 <img src="/icons/calendar-al.svg" alt="date" style={{ width: '14px', height: '14px', marginRight: theme.spacing(1) }} />
//                 <Typography variant="body2" sx={{ fontWeight: 550, fontSize: '12px', color: '#344054' }}>
//                     {date}
//                 </Typography>
//             </ListItem>

//             <Box sx={{ mb: 1 }}>
//               {(logs as any[]).map((activity: any) => ( // Removed index as it's not used in this map
//                 <ListItem
//                   key={activity.id}
//                   disableGutters // Ensures no default ListItem padding
//                   sx={{
//                     py: 1,
//                     // Remove ALL horizontal padding from ListItem to ensure it spans full width
//                     // We will add padding to its *children* instead.
                    
//                     alignItems: 'flex-start',
//                     flexDirection: 'column',
//                     width: '100%' // Ensure ListItem takes full width
//                   }}
//                 >
//                   {/* Content inside ListItem: This Stack receives the horizontal padding */}
//                   <Stack direction="row" alignItems="center" width="100%" sx={{ px: componentPaddingX }}>
//                     <ActivityIcon activityType={activity.activityType} />
//                     <ListItemText
//                       primary={
//                         <Typography variant="body2" sx={{
//                           fontWeight: 400,
//                           fontSize: '13px',
//                           color: '#344054',
//                           ml: 0.8,
//                         }}>
//                           {(() => {
//                             let message = generateActionMessage(activity);
//                             const performerName = activity.performedByUser?.name;
//                             const targetName = activity.targetUser?.name || activity.details?.deletedUserName;

//                             if (performerName) {
//                                 message = message.replace(new RegExp(`\\b${performerName}\\b`, 'g'), `<span style="font-weight: 470; font-size: 13px;">${performerName}</span>`);
//                             }
//                             if (targetName && targetName !== performerName) {
//                                 message = message.replace(new RegExp(`\\b${targetName}\\b`, 'g'), `<span style="font-weight: 470; font-size: 13px;">${targetName}</span>`);
//                             }

//                             return <span dangerouslySetInnerHTML={{ __html: message }} />;
//                           })()}
//                         </Typography>
//                       }
//                       secondary={
//                         <Box component="span" sx={{ display: 'flex', alignItems: 'center', mt: 0.3, ml: 0.8 }}>
//                           <Typography variant="caption" sx={{ color: '#98A2B3', fontSize: '10px', whiteSpace: 'nowrap' }}>
//                             {formatActivityTimestamp(activity.createdAt).time}
//                           </Typography>
//                         </Box>
//                       }
//                       sx={{ ml: 0.3 }}
//                     />
//                   </Stack>
//                   {/* LogDetailContent: This component needs to receive the same horizontal padding to align with other content,
//                       or its ml needs to be adjusted based on the new px on Stack.
//                       For simplicity and consistency, let's wrap it in a Box that applies the padding. */}
//                   <Box sx={{ width: '100%', px: componentPaddingX }}> {/* New: Wrapper for LogDetailContent */}
//                     <LogDetailContent log={activity} />
//                   </Box>
//                 </ListItem>
//               ))}
//             </Box>
//           </React.Fragment>
//         ))}
//       </List>
//     );
//   };

//   return (
//     // Root Box: Ensure it takes 100% width and has no horizontal padding itself
//     <Box sx={{ width: '100%', pt: 0.5, pb: 0.5}}>
//       {/* Titles: Apply horizontal padding directly to them */}
//       <Typography sx={{ fontWeight: 400, fontFamily: 'Inter', fontSize: '16px', color: '#333333', px: componentPaddingX, mb: 2.5, mt: 0 }}>
//         Recent Activities
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 0.8, fontWeight: 600, fontFamily: 'Inter', fontSize: '12px', color: '#333333', px: componentPaddingX }}>
//         Showing {loading || error ? 0 : data?.tenantActivityLogs.length || 0} recent activities
//       </Typography>
//       {renderContent()}
//     </Box>
//   );
// };

// export default RecentActivity;

import React, { useMemo } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  useTheme,
  Avatar,
  CircularProgress,
  Alert,
  Stack,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { gql, useQuery } from '@apollo/client';

const GET_TENANT_ACTIVITY_LOGS = gql`
  query GetTenantActivityLogs($tenantId: ID!, $limit: Int) {
    tenantActivityLogs(tenantId: $tenantId, limit: $limit) {
      id
      activityType
      performedByUser { id name photo }
      targetUser { id name email photo }
      createdAt
      details
    }
  }
`;

interface RecentActivityProps {
  currentTenantId: string | null;
}

// ... (Interfaces and helper functions like generateActionMessage, formatLogDateForGrouping, etc., remain the same) ...

const formatLogDateForGrouping = (isoString: string): string => {
  if (!isoString) return 'Invalid Date';
  return new Date(isoString).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).toUpperCase();
};

const formatActivityTimestamp = (isoString: string): { date: string, time: string } => {
  if (!isoString) return { date: '', time: '' };
  try {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });
    const formattedTime = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    return { date: formattedDate, time: formattedTime };
  } catch (e) {
    console.error("Error formatting timestamp:", isoString, e);
    return { date: 'Invalid Date', time: 'Invalid Time' };
  }
};

const generateActionMessage = (log: any): string => {
  const { activityType, performedByUser, targetUser, details } = log;
  const performerName = performedByUser?.name || 'System';
  const targetName = targetUser?.name || details?.deletedUserName || 'a user';

  switch (activityType) {
    case 'USER_ADDED_TO_TENANT':
      return `New user added by ${performerName}`;
    case 'USER_REMOVED_FROM_TENANT':
      return `User deleted by ${performerName}`;
    case 'USER_ROLE_IN_TENANT_CHANGED':
      return `Role changed for ${targetName} by ${performerName}`;
    case 'TENANT_SETTINGS_UPDATED':
      return `Tenant settings updated by ${performerName}`;
    case 'USER_INVITED_TO_TENANT':
      return `${targetName} invited to tenant by ${performerName}`;
    case 'USER_ACCEPTED_INVITATION':
      return `Email Invitation accepted by ${targetName}`;
    case 'DATA_SOURCE_CREATED':
      return `New data source "${details?.name || 'unnamed'}" was added by ${performerName}`;
    case 'DATA_SOURCE_DELETED':
      return `Data source "${details?.name || 'unnamed'}" was deleted by ${performerName}`;
    default:
      return `${activityType.replace(/_/g, ' ').toLowerCase()} by ${performerName}`;
  }
};


const groupLogsByDate = (logs: any[]): Record<string, any[]> => {
  if (!logs) return {};
  return logs.reduce((acc, log) => {
    const dateKey = formatLogDateForGrouping(log.createdAt);
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(log);
    return acc;
  }, {} as Record<string, any[]>);
};

const roleDotColors: { [key: string]: string } = {
  Editor: '#0064FF',
  Viewer: '#6C737F',
  Admin: '#0064FF',
};

const RoleDisplay: React.FC<{ role: string }> = ({ role }) => {
  const capitalizedRole = role ? role.charAt(0).toUpperCase() + role.slice(1).toLowerCase() : 'N/A';
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', backgroundColor: roleDotColors[capitalizedRole] || '#6C737F', mr: 0.5 }} />
      <Typography variant="caption" sx={{ color: '#344054', fontWeight: 400, fontSize: '10px' }}>{capitalizedRole}</Typography>
    </Box>
  );
};

const ActivityIcon: React.FC<{ activityType: string }> = ({ activityType }) => {
  const theme = useTheme();
  let iconSrc = '/icons/edit-al.svg';

  if (activityType.includes('ADD') || activityType.includes('INVITE') || activityType.includes('CREATED')) {
    iconSrc = '/icons/add-al.svg';
  } else if (activityType.includes('REMOVED') || activityType.includes('DELETED')) {
    iconSrc = '/icons/delete-al.svg';
  } else if (activityType.includes('ROLE') || activityType.includes('UPDATED')) {
    iconSrc = '/icons/edit-al.svg';
  } else if (activityType.includes('ACCEPT')) {
    iconSrc = '/icons/email-al.svg';
  }

  return (
    <Box sx={{
      width: '22px',
      height: '22px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      border: `1px solid ${theme.palette.grey[300]}`,
      bgcolor: 'background.paper', // Use paper background to sit cleanly on the line
      position: 'relative',
      zIndex: 1, // Ensure it's on top of the dashed line
      aspectRatio: '1 / 1',
      flexShrink: 0,
    }}>
      <img src={iconSrc} alt={`${activityType} icon`} style={{ width: '12px', height: '12px' }} />
    </Box>
  );
};

const LogDetailContent: React.FC<{ log: any }> = ({ log }) => {
    // This component remains unchanged
    const { activityType, targetUser, details } = log;

  const typesWithDetailBox = [
    'USER_ADDED_TO_TENANT',
    'USER_REMOVED_FROM_TENANT',
    'USER_ROLE_IN_TENANT_CHANGED',
    'USER_INVITED_TO_TENANT',
  ];

  if (!typesWithDetailBox.includes(activityType)) {
    return null;
  }

  const userToShow = {
    name: details?.deletedUserName || targetUser?.name,
    email: details?.deletedUserEmail || targetUser?.email,
    photo: details?.deletedUserPhoto || targetUser?.photo,
    role: details?.newRole || details?.role || (activityType === 'USER_INVITED_TO_TENANT' ? details?.roleInTenant : 'Editor')
  };

  let barColor = '#F79009';
  if (activityType === 'USER_ADDED_TO_TENANT' || activityType === 'USER_INVITED_TO_TENANT') {
    barColor = '#0064FF';
  } else if (activityType === 'USER_REMOVED_FROM_TENANT') {
    barColor = '#D92D20';
  }

  return (
    <Box sx={{
      position: 'relative',
      ml: '34px', // Adjusted margin to align with icon + padding
      mt: 0.8,
      bgcolor: '#FAFAFA',
      borderRadius: '6px',
      p: 1,
      pl: '18px',
    }}>
      <Box sx={{
        position: 'absolute',
        left: '6px',
        top: 6,
        bottom: 6,
        width: '2px',
        bgcolor: barColor,
        borderRadius: '2px',
      }} />

      {(() => {
        switch (activityType) {
          case 'USER_ADDED_TO_TENANT':
          case 'USER_REMOVED_FROM_TENANT':
          case 'USER_INVITED_TO_TENANT':
            if (!userToShow.name) return null;
            return (
              <Stack direction="row" spacing={1} alignItems="center">
                <Avatar src={userToShow.photo} sx={{ width: 24, height: 24 }} />
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 400, color: '#344054', fontSize: '11px' }}>{userToShow.name}</Typography>
                  <Typography variant="caption" sx={{ color: '#667085', fontSize: '10px' }}>{userToShow.email}</Typography>
                </Box>
              </Stack>
            );
          case 'USER_ROLE_IN_TENANT_CHANGED':
            return (
              <Stack direction="row" spacing={0.5} alignItems="center">
                <RoleDisplay role={details?.oldRole || 'Role'} />
                <Typography sx={{ color: '#667085', fontSize: '12px' }}>»</Typography>
                <RoleDisplay role={details?.newRole || 'Role'} />
              </Stack>
            );
          default:
            return null;
        }
      })()}
    </Box>
  );
};


const RecentActivity: React.FC<RecentActivityProps> = ({ currentTenantId }) => {
  const theme = useTheme();
  const componentPaddingX = 2;

  const { loading, error, data } = useQuery(GET_TENANT_ACTIVITY_LOGS, {
    variables: { tenantId: currentTenantId, limit: 5 },
    skip: !currentTenantId,
    fetchPolicy: 'network-only',
  });

  const groupedActivities = useMemo(() => {
    if (!data?.tenantActivityLogs) return {};
    return groupLogsByDate(data.tenantActivityLogs);
  }, [data]);


  const renderContent = () => {
    if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}><CircularProgress size={20} /></Box>;
    if (error) return <Alert severity="error" sx={{ m: 0.5, fontSize: '0.8rem' }}>Failed to load activities.</Alert>;
    if (Object.keys(groupedActivities).length === 0) return <Typography variant="body2" color="text.secondary" sx={{ p: 1, textAlign: 'center', fontSize: '0.8rem' }}>No recent activities to show.</Typography>;

    return (
      <List disablePadding sx={{ width: '100%' }}>
        {Object.entries(groupedActivities).map(([date, logs]) => (
          <React.Fragment key={date}>
            <ListItem sx={{ py: 0.5, px: componentPaddingX, bgcolor: '#FAFAFA', borderTop: '1px solid #EAECF0', borderBottom: '1px solid #EAECF0' }}>
              <img src="/icons/calendar-al.svg" alt="date" style={{ width: '14px', height: '14px', marginRight: theme.spacing(1) }} />
              <Typography variant="body2" sx={{ fontWeight: 550, fontSize: '12px', color: '#344054' }}>
                {date}
              </Typography>
            </ListItem>

            <Box sx={{ position: 'relative', px: componentPaddingX }}>
              {/* The Dashed Line */}
              <Box sx={{
                position: 'absolute',
                left: `calc(${theme.spacing(componentPaddingX)} + 10px)`, // Padding + half of icon width
                top: 0,
                bottom: 0,
                width: '1.5px',
                zIndex: 0,
                backgroundImage: `repeating-linear-gradient(transparent 0, transparent 6px, ${theme.palette.grey[300]} 6px, ${theme.palette.grey[300]} 12px)`,
              }} />

              {(logs as any[]).map((activity: any) => (
                <ListItem
                  key={activity.id}
                  disableGutters
                  sx={{
                    py: 1.5,
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    width: '100%',
                    position: 'relative', // Needed for z-index context
                  }}
                >
                  <Stack direction="row" alignItems="flex-start" width="100%">
                    <ActivityIcon activityType={activity.activityType} />
                    <ListItemText
                      primary={
                        <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '13px', color: '#344054', ml: 1.5, }}>
                          {(() => {
                            let message = generateActionMessage(activity);
                            const performerName = activity.performedByUser?.name;
                            const targetName = activity.targetUser?.name || activity.details?.deletedUserName;
                            if (performerName) {
                              message = message.replace(new RegExp(`\\b${performerName}\\b`, 'g'), `<span style="font-weight: 470; font-size: 13px;">${performerName}</span>`);
                            }
                            if (targetName && targetName !== performerName) {
                              message = message.replace(new RegExp(`\\b${targetName}\\b`, 'g'), `<span style="font-weight: 470; font-size: 13px;">${targetName}</span>`);
                            }
                            return <span dangerouslySetInnerHTML={{ __html: message }} />;
                          })()}
                        </Typography>
                      }
                      secondary={
                        <Box component="span" sx={{ display: 'flex', alignItems: 'center', mt: 0.3, ml: 1.5 }}>
                          <Typography variant="caption" sx={{ color: '#98A2B3', fontSize: '10px', whiteSpace: 'nowrap' }}>
                            {formatActivityTimestamp(activity.createdAt).time}
                          </Typography>
                        </Box>
                      }
                      sx={{ m: 0 }}
                    />
                  </Stack>
                  <LogDetailContent log={activity} />
                </ListItem>
              ))}
            </Box>
          </React.Fragment>
        ))}
      </List>
    );
  };

  return (
    <Box sx={{ width: '100%', pt: 0.5, pb: 0.5 }}>
      <Typography sx={{ fontWeight: 400, fontFamily: 'Inter', fontSize: '16px', color: '#333333', px: componentPaddingX, mb: 2.5, mt: 0 }}>
        Recent Activities
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.8, fontWeight: 600, fontFamily: 'Inter', fontSize: '12px', color: '#333333', px: componentPaddingX }}>
        Showing {loading || error ? 0 : data?.tenantActivityLogs.length || 0} recent activities
      </Typography>
      {renderContent()}
    </Box>
  );
};

export default RecentActivity;